export { CookiesLayout } from './CookiesLayout'
